import { vestResolver } from "@hookform/resolvers/vest";
import Lottie from "lottie-react";
import { FC, useEffect, useState } from "react";
import { UseTranslationContext } from "../Context/TranslationContext";

import spinner from "../FormModel/lottie_spinner_blue.json";

interface PopupProps {
    displayActive: boolean;
}

const SimulationBlockerComponent: FC<PopupProps> = (props) => {

const {getKeyFromKeyId} = UseTranslationContext();

const GetPopupVisual = () => {
    if(props.displayActive)
    {
        return(
            <div className="pop-up">
                <div className="box-pop-up">
                    <h3 className="head-pop-up">{getKeyFromKeyId("SIMU_LOADING_MSG")}</h3>
                    <div className="form-block w-form loadingPopup">
                        <Lottie animationData={spinner} autoPlay={true} loop={true} className="lottie-animation-big" />
                    </div>
                </div>
            </div>
            );
    }
    else
    {
        return (<></>);
    }
}

  return (
    <>
        {GetPopupVisual()}
    </>
  );

}

export default SimulationBlockerComponent;